'use strict';

var number = require('../../../utils/mix/number.cjs');
var progress = require('../../../../../../motion-utils/dist/es/progress.cjs');

function fillOffset(offset, remaining) {
    const min = offset[offset.length - 1];
    for (let i = 1; i <= remaining; i++) {
        const offsetProgress = progress.progress(0, remaining, i);
        offset.push(number.mixNumber(min, 1, offsetProgress));
    }
}

exports.fillOffset = fillOffset;
//# sourceMappingURL=fill.cjs.map
